'use client'

import { Wallets, walletsMap } from '@/shared/constants/wallets'
import { useSolanaAdapterWallet } from '@/shared/wallet/useSolanaAdapterWallet'
import { useWalletConnectWallet } from '@/shared/wallet/useWalletConnectWallet'
import type { AppWalletAdapter } from '@/shared/wallet/wallet.types'

export function useAppWallet(walletType: string): AppWalletAdapter {
  const solanaWallet = useSolanaAdapterWallet(walletType)
  const walletConnectWallet = useWalletConnectWallet()

  return walletType === walletsMap[Wallets.WalletConnect] ? walletConnectWallet : solanaWallet
}
